export default __webpack_public_path__ + "static/media/Cardrooms.09907357.jpg";